import React from "react";
import {
  Box,
  Button,
  Card,
  CardBody,
  Flex,
  Heading,
  Text,
  VStack,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

const WorkbookCard = ({
  title,
  areaLabel,
  result,
  description,
  ctaLabel,
  ctaTo,
  ctaState,
  onCtaClick,
  accentColor = "blue.500",
}) => {
  return (
    <Card
      h="100%"
      borderWidth="1px"
      borderColor="gray.200"
      borderTopWidth="6px"
      borderTopColor={accentColor}
      borderRadius="2xl"
      bg="white"
      boxShadow="sm"
    >
      <CardBody display="flex" flexDirection="column" gap={6} px={6} py={6}>
        <VStack align="stretch" spacing={4} flex="1">
          <Flex align="start" justify="space-between" gap={4}>
            <VStack align="start" spacing={2} flex="1" minW={0}>
              {areaLabel ? (
                <Text
                  fontSize="xs"
                  fontWeight="bold"
                  textTransform="uppercase"
                  letterSpacing="0.12em"
                  color="gray.500"
                >
                  {areaLabel}
                </Text>
              ) : null}

              <Heading size="md" color="gray.900">
                {title}
              </Heading>
            </VStack>

            {result ? (
              <Box
                px={3}
                py={2}
                borderRadius="xl"
                bg="gray.50"
                borderWidth="1px"
                borderColor="gray.100"
                minW="fit-content"
              >
                <Text fontSize="xs" color="gray.500" mb={1} textTransform="uppercase" letterSpacing="0.08em">
                  Result
                </Text>
                <Text fontSize="sm" fontWeight="semibold" color="gray.800">
                  {result}
                </Text>
              </Box>
            ) : null}
          </Flex>

          {description ? (
            <Text color="gray.600" lineHeight="tall" whiteSpace="pre-line" wordBreak="break-word">
              {description}
            </Text>
          ) : null}
        </VStack>

        {ctaLabel && ctaTo ? (
          <Box pt={2}>
            <Button
              as={RouterLink}
              to={ctaTo}
              state={ctaState}
              onClick={onCtaClick}
              colorScheme="blue"
              variant="outline"
              borderRadius="xl"
              w={{ base: "100%", sm: "auto" }}
            >
              {ctaLabel}
            </Button>
          </Box>
        ) : null}
      </CardBody>
    </Card>
  );
};

export default WorkbookCard;
